import Button from '@material-ui/core/Button';
import React from 'react';
import { Modal } from 'react-bootstrap';
import './EditorsModal.scss';
import styles from './RoadCondition.module.scss';

const EditorModal=(props)=> {
  
    return (
      <>
        <Modal
          show={props.show}
          onHide={props.onHide}
          backdrop="static"
          keyboard={false}
          centered
          dialogClassName="editorsModal"
        >
          <Modal.Header closeButton >
            <Modal.Title>{props.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           <ul>
           {props.modalBody?.map(item => (
                        <li key={item}>
                          {item}
                        </li>
                    ))}
            </ul>
          </Modal.Body>

          <Modal.Footer>
          <Button className={styles.submitButton} variant="contained" color="primary" onClick={props.onSave}> Submit</Button>
            <div style={{ width:"2px" }}></div>
            <Button className={styles.cancelButton} variant="outlined" color="secondary" onClick={props.onDiscard}>
                         Discard
            </Button>
                    
                </Modal.Footer>

        </Modal>
      </>
    );
  }
  export default EditorModal;